import React from 'react';
import PropTypes from 'prop-types';
import PoorText from 'components/PoorText';
import './CountryPageActivitiesCampaignsBlock.scss';
import Link from 'components/Link';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';

const CountryPageActivitiesCampaignsBlockItem = ({
  heading,
  descriptionHtml,
  link,
}) => {
  return (
    <div className="country-page-activities-campaigns-block__item">
      {heading && (
        <h2 className="country-page-activities-campaigns-block__item-heading">
          {heading}
        </h2>
      )}
      {descriptionHtml && (
        <PoorText
          className="country-page-activities-campaigns-block__item-description"
          text={descriptionHtml}
        />
      )}
      {link && (
        <LinkButton
          {...link}
          theme={LINK_BUTTON_THEMES.dark}
          className="country-page-activities-campaigns-block__item-link"
        />
      )}
    </div>
  );
};

CountryPageActivitiesCampaignsBlockItem.propTypes = {
  heading: PropTypes.string,
  link: PropTypes.exact(Link.propTypes),
  descriptionHtml: PropTypes.string,
};

export default CountryPageActivitiesCampaignsBlockItem;
